import { useXHR } from "@sembark-travel/xhr"
import {
	NewWhatsAppCloudApiIntegrationForm,
	TIntegration,
} from "../../../../Integrations"
import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { showSnackbar } from "@sembark-travel/ui-snackbar"

export default function NewWhatsAppCloudApiIntegrationPage() {
	const xhr = useXHR()
	const navigate = useNavigate()

	return (
		<>
			<Helmet>
				<title>New WhatsApp Cloud API Integration</title>
			</Helmet>
			<Breadcrumbs
				title="New WhatsApp Cloud API Integration"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[generatePath("/integrations/new"), "New"],
					["", "WhatsApp Cloud API"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<NewWhatsAppCloudApiIntegrationForm
								initialValues={{
									name: "WhatsApp Business",
									description: "Customer communication via WhatsApp",
								}}
								onSubmit={async (values) => {
									const integration = await xhr
										.post<{ data: TIntegration }>("integrations", {
											...values,
										})
										.then((resp) => resp.data.data)
									showSnackbar("Integration created successfully.")
									navigate("/integrations/:integrationId", {
										params: {
											integrationId: String(integration.uid),
										},
										replace: true,
									})
								}}
								onCancel={() => {
									navigate("/org/integrations", { replace: true })
								}}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
